<template>
  <main class="page">
    <page-header title="我的" />
    <section class="me-card">
      <div class="me-head">
        <span class="me-avatar">{{ (profile.name || '正').slice(0, 1) }}</span>
        <div>
          <strong>{{ profile.name || '宜投同事' }}</strong>
          <small>宜投地产{{ profile.mobile ? ' · ' + profile.mobile : '' }}</small>
        </div>
      </div>
      <div class="me-stats">
        <div><strong>{{ count('waitMeet') }}</strong><span>待约访</span></div>
        <div><strong>{{ count('meet') }}</strong><span>约访中</span></div>
        <div><strong>{{ count('success') }}</strong><span>已成交</span></div>
      </div>
    </section>
    <p v-if="error" class="error-message">
      {{ error }}
      <button class="text-button" @click="load">重试</button>
    </p>
    <div class="sec-head">
      <h2>今天和本周</h2>
    </div>
    <section class="group">
      <div v-for="item in metrics" :key="item.key" class="menu-row">
        <span>{{ item.label }}</span>
        <strong>{{ count(item.key) }}</strong>
      </div>
    </section>
    <section class="group">
      <router-link class="menu-row" to="/task">
        <app-icon name="task" />
        <span>我的任务</span>
        <app-icon class="chev" name="arrow" />
      </router-link>
      <button class="menu-row" @click="showPassword = true">
        <app-icon name="shield" />
        <span>修改登录密码</span>
        <app-icon class="chev" name="arrow" />
      </button>
      <button class="menu-row" @click="logout">
        <app-icon name="logout" />
        <span>退出登录</span>
        <app-icon class="chev" name="arrow" />
      </button>
    </section>
    <p class="me-foot">宜投地产 · 新房 · 公寓 · 商铺</p>
    <transition name="sheet">
      <div v-if="showPassword" class="sheet-layer">
        <div class="scrim" @click="closePassword" @touchmove.prevent />
        <section class="sheet" role="dialog" aria-modal="true" aria-label="修改登录密码">
          <div class="sheet-grab" />
          <header class="sheet-head">
            <div>
              <h2>修改登录密码</h2>
              <p>至少 6 位，修改后下次登录生效</p>
            </div>
            <button class="sheet-close" :disabled="saving" @click="closePassword">收起</button>
          </header>
          <form @submit.prevent="updatePassword">
            <label class="field">
              <span>新密码</span>
              <input v-model="password" type="password" minlength="6" autocomplete="new-password" placeholder="至少 6 位" required />
            </label>
            <label class="field">
              <span>确认新密码</span>
              <input v-model="confirmation" type="password" minlength="6" autocomplete="new-password" placeholder="再次输入新密码" required />
            </label>
            <p v-if="passwordError" class="error-message">{{ passwordError }}</p>
            <button class="button full" type="submit" :disabled="saving" style="margin-top:18px">
              <span v-if="saving" class="spinner" />
              {{ saving ? '正在保存' : '保存新密码' }}
            </button>
          </form>
        </section>
      </div>
    </transition>
  </main>
</template>
<script>
import { clearSession } from '../../common/session'
export default {
  data() {
    return {
      counts: {},
      error: '',
      showPassword: false,
      password: '',
      confirmation: '',
      passwordError: '',
      saving: false,
      metrics: [
        { key: 'waitMeetEnd', label: '今日约访跟进' },
        { key: 'comeExpect', label: '今日预计来访' },
        { key: 'comeActual', label: '今日实际来访' },
        { key: 'successToday', label: '今日成交' },
        { key: 'comeTaskWeek', label: '本周来访任务完成' },
        { key: 'successTaskMonth', label: '本月成交任务完成' }
      ]
    }
  },
  computed: {
    profile() {
      return this.$store.state.profile || {}
    }
  },
  watch: {
    showPassword(value) {
      document.body.classList.toggle('modal-open', value)
    }
  },
  created() {
    this.load()
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open')
  },
  methods: {
    count(key) {
      return this.counts[key] ? this.counts[key].num : '—'
    },
    async load() {
      this.error = ''
      try {
        this.counts = (await this.$api.post('/api/employee/counts', {})).counts || {}
      } catch (e) {
        this.error = e.message
      }
    },
    closePassword() {
      if (this.saving) return
      this.showPassword = false
      this.password = ''
      this.confirmation = ''
      this.passwordError = ''
    },
    async updatePassword() {
      if (this.saving) return
      this.passwordError = ''
      if (this.password.length < 6) {
        this.passwordError = '密码不能少于 6 位'
        return
      }
      if (this.password !== this.confirmation) {
        this.passwordError = '两次输入的密码不一致'
        return
      }
      this.saving = true
      try {
        await this.$api.post('/api/employee/update', {
          password: this.password,
          password_confirmation: this.confirmation
        })
        this.saving = false
        this.closePassword()
        this.$toast('密码已修改')
      } catch (e) {
        this.passwordError = e.message
      } finally {
        this.saving = false
      }
    },
    async logout() {
      try {
        await this.$dialog.confirm({
          title: '退出登录',
          message: '确认退出当前账号？未保存的草稿将在下次登录此账号时保留。'
        })
        clearSession(this.$store)
        this.$router.replace('/')
      } catch (e) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/employee/index.vue